import {FormProps, Option} from 'platform/components';

import {always, times} from 'ramda';

import {GetOrderSetDefaultContactPersonApiResponse} from '@dms/api/core';
import {PhoneNumber} from '@dms/api/shared';

import {isNotNilOrEmpty, Nullish} from 'shared/web';

import {EMPTY_WHEEL} from '../constants/emptyWheel';
import {TireSetDetailFormDefinition} from '../types/TireSetDetailFormDefinition';

// eslint-disable-next-line max-params -- Pre-existing violation
export const getDraftTireSetDefaultValues = (
  tireCategoryId: string | Nullish,
  locationOptions: Option[],
  defaultStoreUntil: string | Nullish,
  defaultManufacturerId: string | Nullish,
  defaultContactPerson: GetOrderSetDefaultContactPersonApiResponse,
  tenantPhoneInfo: PhoneNumber,
  defaultTireConditionId: string | Nullish
): FormProps<TireSetDetailFormDefinition>['defaultValues'] => ({
  numberOfTires: 4,
  categoryId: tireCategoryId,
  storedUntil: defaultStoreUntil,
  isReplacement: false,
  tireSetRequestEnabled: false,
  neededAtTime: '07:00',
  wheels: times(always(EMPTY_WHEEL), 4).map((wheel, index) => ({
    ...wheel,
    manufacturer: defaultManufacturerId,
    location: locationOptions?.[index % locationOptions?.length]?.value,
    tireCondition: defaultTireConditionId,
    hasHubcap: wheel.hasHubcap ?? false,
    hasWheelLocks: wheel.hasWheelLocks ?? false,
  })),
  contactInformation: isNotNilOrEmpty(defaultContactPerson?.contactInformation)
    ? {
        id: defaultContactPerson?.contactInformation?.id,
        contactId: defaultContactPerson?.contactInformation?.contactId,
        name: defaultContactPerson?.contactInformation?.name,
        email: defaultContactPerson?.contactInformation?.email,
        phoneNumber: {
          countryCode:
            defaultContactPerson?.contactInformation?.phoneNumber?.countryCode ??
            tenantPhoneInfo.countryCode,
          number:
            defaultContactPerson?.contactInformation?.phoneNumber?.number ?? tenantPhoneInfo.number,
          prefix:
            defaultContactPerson?.contactInformation?.phoneNumber?.prefix ?? tenantPhoneInfo.prefix,
        },
      }
    : {
        phoneNumber: {
          countryCode: tenantPhoneInfo.countryCode,
          number: tenantPhoneInfo.number,
          prefix: tenantPhoneInfo.prefix,
        },
      },
});
